<template>
  <div class="money-input">
    <div class="hr"></div>
    <div class="money-input-label" :class="{ required: required }">
      {{ label }}：
    </div>
    <van-field
      v-model="money"
      readonly
      size="large"
      style="font-size:25px;"
      :label-width="40"
      label-class="money-input-field-label"
      :placeholder="'请输入' + placeholder"
      @touchstart.native.stop="show = true"
    >
      <template #label>
        <span class="money-input-icon">￥</span>
      </template>
    </van-field>

    <van-number-keyboard
      :show="show"
      theme="custom"
      v-model="money"
      extra-key="."
      close-button-text="完成"
      @blur="show = false"
      @input="handleInput"
      :z-index="10000"
    />
  </div>
</template>

<script>
import { Field, NumberKeyboard } from "vant";
import cloneDeep from "lodash/cloneDeep";

export default {
  components: {
    [Field.name]: Field,
    [NumberKeyboard.name]: NumberKeyboard,
  },
  props: {
    value: {
      type: [String, Number],
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  model: {
    prop: "value",
    event: "update",
  },
  data() {
    return {
      money: "",
      show: false,
    };
  },
  watch: {
    value(val) {
      this.copyData(val);
    },
    money(val) {
      this.$emit("update", val);
    },
  },
  created() {
    this.copyData();
  },
  methods: {
    copyData(val) {
      const value = val ? val : this.value;
      // this.moeny = cloneDeep(value);
      // setTimeout(() => {
      this.money = cloneDeep(value);
      // }, 0);
    },
    handleInput() {
      const moeny = this.money;

      if (
        moeny &&
        moeny.indexOf(".") > -1 &&
        moeny.toString().split(".").length &&
        moeny.toString().split(".")[1].length >= 2
      ) {
        setTimeout(() => {
          this.money = moeny;
        }, 0);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.money-input {
  padding: 0 16px 10px 16px;
  .hr {
    padding: 1px;
    background: #f1f1f1;
    margin-left: -16px;
    margin-right: -16px;
    margin-bottom: 16px;
  }
  &-icon {
    font-size: 26px;
  }
  &-label {
    font-size: 14px;
    width: 100px;
    position: relative;
  }
}
/deep/ .money-input-field-label {
  line-height: 36px;
}
</style>
